export const FONT_FAMILY = 'var(--font-stack)';
